export default async function (room) {

  try {

    const { localParticipant } = room

    for (const [, publication] of localParticipant.videoTracks) {

      await publication.track.stop()

    }
    room.disconnect()

    return true

  }
  catch (e) {

    return false

  }

}
